import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { connect } from 'react-redux';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import Image from '../../components/Image';
import { RICH_TEXT_LAYOUTS } from '../../Constants';
import VideoPlayer from '../../../client/components/VideoPlayer';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';
import { getLocalStorage } from '../../actions/LocalStorage';
import ContentRelevancyDisplay from './ContentRelevancyDisplay';

class DynamicRichTextSlide extends Component {
    static propTypes = {
        currentUser: PropTypes.object,
        name: PropTypes.string,
        content: PropTypes.shape({
            description: PropTypes.string,
            imageUrl: PropTypes.string,
            blocks: PropTypes.array,
            resources: PropTypes.string,
            hideContentRelevancyQuestion: PropTypes.bool
        }),
        onChange: PropTypes.func,
        canMoveToNext: PropTypes.func,
        nextSectionName: PropTypes.string,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func,
        isWrapUp: PropTypes.bool,
        isRefSheet: PropTypes.bool,
        idToken: PropTypes.string,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const { canMoveToNext, onChange } = this.props;
        if (canMoveToNext) canMoveToNext(true);
        if (onChange) {
            const isCompleted = true;

            const isAnswered = true;
            onChange(null, isCompleted, isAnswered);
        }
    }

    _getSlideContent = () => {
        const {
            currentUser,
            nextSectionName,
            content = {},
            sendWorkspaceSegementEvent,
            sectionItemId,
            isWrapUp = false,
            isRefSheet = false
        } = this.props;
        const { blocks = [], resources = null } = content;
        let description;
        let imageUrl;
        let contentToRender;
        let videoUrl;
        let audioUrl;
        let key;
        let wrapText;
        let authToken;

        const hideContentRelevancyQuestion = isWrapUp ? content.hideContentRelevancyQuestion || false : true;

        return blocks.map((block, index) => {
            if (!block) {
                return null;
            }
            console.log('Rendering block:', block);
            description = block.description || '';
            imageUrl = block.imageUrl || '';
            videoUrl = block.videoUrl || '';
            audioUrl = block.audioUrl || '';
            wrapText = block.wrapText || false;
            key = block.id || `block-${index}`;
            const userVerbAuthId = getLocalStorage({ key: 'verbAuthId', dispatchDisabled: true }) || '';

            if (
                !block.layout ||
                block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_IMAGE ||
                block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_ONLY
            ) {
                contentToRender = (
                    <Fragment>
                        <div className={'no-horizontal-margin row'}>
                            <RichTextDisplay
                                className={'playerDescription'}
                                htmlToDisplay={description}
                                currentUser={currentUser}
                                nextSectionName={nextSectionName}
                            />
                        </div>
                        <div className={'no-horizontal-margin col-12'}>
                            <Image className={'richTextSlide-image-center'} src={imageUrl} />
                        </div>
                    </Fragment>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.LEFT_TEXT_RIGHT_IMAGE) {
                contentToRender = (
                    <div className={cns('no-horizontal-margin row', { 'wrap-text': wrapText })}>
                        {wrapText && (
                            <div className={'richTextSlide-image-right text-wrap-image-right'}>
                                <Image src={imageUrl} />
                            </div>
                        )}
                        <RichTextDisplay
                            className={cns('playerDescription image-is-right', { 'col-12 col-lg-6': !wrapText })}
                            htmlToDisplay={description}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                        {!wrapText && (
                            <div className={'richTextSlide-image-right col-12 col-lg-6'}>
                                <Image src={imageUrl} />
                            </div>
                        )}
                    </div>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.RIGHT_TEXT_LEFT_IMAGE) {
                contentToRender = (
                    <div className={cns('no-horizontal-margin row', { 'wrap-text': wrapText })}>
                        <div
                            className={cns(
                                'richTextSlide-image-left',
                                { 'text-wrap-image-left': wrapText },
                                { 'col-12 col-lg-6': !wrapText }
                            )}
                        >
                            <Image src={imageUrl} />
                        </div>
                        <RichTextDisplay
                            className={cns('playerDescription image-is-left', { 'col-12 col-lg-6': !wrapText })}
                            htmlToDisplay={description}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                    </div>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_VIDEO) {
                contentToRender = (
                    <div className={'no-horizontal-margin col-12'}>
                        <RichTextDisplay
                            className={'playerDescription'}
                            htmlToDisplay={description}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                        <VideoPlayer className={'richTextSlide-video'} src={videoUrl} />
                        <br />
                    </div>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_AUDIO) {
                contentToRender = (
                    <div className={'no-horizontal-margin col-12'}>
                        <RichTextDisplay
                            className={'playerDescription'}
                            htmlToDisplay={description}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                        <VideoPlayer className={'richTextSlide-audio'} src={audioUrl} />
                    </div>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.TEXT_SIDE_BY_SIDE) {
                contentToRender = (
                    <div className={'no-horizontal-margin row'}>
                        <RichTextDisplay
                            className={'side-by-side col-12 col-sm-6 playerDescription'}
                            htmlToDisplay={block.textSideA || ''}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                        <RichTextDisplay
                            className={'side-by-side col-12 col-sm-6 playerDescription'}
                            htmlToDisplay={block.textSideB || ''}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                    </div>
                );
            } else if (block.layout === RICH_TEXT_LAYOUTS.CENTERED_TEXT) {
                contentToRender = (
                    <Fragment>
                        <div className={'no-horizontal-margin row centered-wrapper'}>
                            <RichTextDisplay
                                className={'playerDescription'}
                                htmlToDisplay={description}
                                currentUser={currentUser}
                                nextSectionName={nextSectionName}
                            />
                        </div>
                    </Fragment>
                );
            }
            return (
                <Fragment key={key}>
                    {contentToRender}
                    {!hideContentRelevancyQuestion && !isRefSheet && index === blocks.length - 1 && (
                        <ContentRelevancyDisplay parentId={sectionItemId} />
                    )}
                    {resources && index === blocks.length - 1 && !isRefSheet && (
                        <div className={'no-horizontal-margin resource-block'}>
                            <div>
                                <p>
                                    <strong>Resources</strong>
                                </p>
                            </div>
                            <div>
                                <RichTextDisplay
                                    className={'playerDescription'}
                                    htmlToDisplay={resources}
                                    currentUser={currentUser}
                                    nextSectionName={nextSectionName}
                                />
                            </div>
                        </div>
                    )}
                </Fragment>
            );
        });
    };

    render() {
        const { name, sectionId, sectionItemId, currentUser, hideBookmark, isRefSheet = false } = this.props;
        return (
            <div className={'dynamicRichTextSlide row'}>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={cns('playerContent w-100')}>{this._getSlideContent()}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        auth: { idToken }
    } = state;

    return {
        idToken
    };
};

export const DynamicRichTextSlideComponent = DynamicRichTextSlide;
export default connect(mapStateToProps)(TrackPlayerSlideComponent(DynamicRichTextSlide));
